module.exports = __webpack_public_path__ + "img/1566937631.4ac8ec7e.jpg";